<template>
  <collapsed-section v-if="loadingContractTemplate || contractTemplate" :title="sectionTitle" :open="true" class="mb-5">
    <div v-if="loadingContractTemplate" class="text-center my-3">
      <span class="inline-loader"></span>
    </div>
    <template v-else>
      <pdf-container :site-id="siteId"/>
      <signature-pad
        v-if="contractTemplate.signatureRequired"
        :value="value"
        :validation-message="validationMessage"
        @input="$emit('input', $event)"/>
    </template>
  </collapsed-section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import CollapsedSection from '../../Layout/CollapsedSection.vue'
import PdfContainer from './PdfContainer.vue'
import SignaturePad from './SignaturePad.vue'

export default {
  name: 'Contract',
  props: {
    siteId: { type: String, required: true },
    value: { type: String, default: '' },
    validationMessage: { type: String, default: '' }
  },
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('ClientRegistration', [
      'contractTemplate',
      'loadingContractTemplate'
    ]),
    sectionTitle () {
      return this.contractTemplate?.templateName || 'Contract'
    }
  },
  methods: {
    ...mapActions('ClientRegistration', [
      'fetchContractTemplate'
    ]),
    tryFetch () {
      this.error = ''
      this.fetchContractTemplate({ siteId: this.siteId })
        .catch(error => { this.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.tryFetch()
  },
  components: {
    'collapsed-section': CollapsedSection,
    'pdf-container': PdfContainer,
    'signature-pad': SignaturePad
  }
}
</script>
